import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import TitleLayout from '../../kosherTeudot/generic/TitleLayout'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'
import CalendatDay from '../../../../../generic/icons/IconLib/CalendarIcon'
import InvoiceIcon from '../../../../../generic/icons/IconLib/InvoiceIcon'
import UserIcon from '../../../../../generic/icons/IconLib/UserIcon'
import TeudaDetailsItem from './TeudaDetailsItem'
import { convertToDate } from '../../../../../modules/convertDateString'
import { ITeudotWithDetailsAndProblems } from '../../../../../modules/API/TeudotProblems/models/problems'
import { ISelectedProduct } from '../types/problemModal'
import { useProblemHelpers, getStatusColor } from '../hooks/useProblemHelpers'  
import StatusBadge from '../Components/StatusBadge'

interface Props extends ITeudotWithDetailsAndProblems {
  handleSelectProduct: (item: ISelectedProduct) => void
}

const TeudaWithDetails = (props: Props) => {
  const {
    Delivery_Num,
    Delivery_Sub,
    PalletDetails,
    Customer_Name,
    Delivery_Date,
  
    handleSelectProduct
  } = props
  
  const [isOpen, setIsOpen] = useState(false)
  
  const handleClick = () => {
    setIsOpen(!isOpen)
  }
  // Calculate overall teuda problem status
  const allProblems = useMemo(() => {
    return PalletDetails.flatMap(detail => detail.Problems || [])
  }, [PalletDetails])

  const {
    hasProblems: teudaHasProblems,
    statusCounts,
    displayColor
  } = useProblemHelpers(allProblems)

  const productsWithProblems = useMemo(() => {
    return PalletDetails.filter(detail => 
      detail.Problems && detail.Problems.length > 0
    ).length
  }, [PalletDetails])
 
  return (
    <MainWrapper
      onClick={handleClick}
      $hasProblems={teudaHasProblems}
    >
      <TitleWrapper>
        <TitleLayout>
          <TitleRow>
            <TitleRowItem 
              name={`${Customer_Name.trim()}`}
              icon={<UserIcon />}
            />
            <TitleRowItem 
              name={`${convertToDate(Delivery_Date)}`}
              icon={<CalendatDay />}
            />
          </TitleRow>
          <TitleRow>
            <TitleRowItem 
              name={`${Delivery_Num}-${Delivery_Sub}`}
              icon={<InvoiceIcon />}
            />
            <TeudaProblemSummary>
              <StatusBadge statusColor={displayColor}>
                {teudaHasProblems ? 
                  `${productsWithProblems}/${PalletDetails.length} פריטים עם פניות` :
                  'ללא פניות'
                }
              </StatusBadge>
              {teudaHasProblems && (
                <ProblemStatusCounts>
                  {statusCounts.waiting > 0 && (
                    <StatusCount $statusColor={getStatusColor(0)}>
                      {statusCounts.waiting} פתוח
                    </StatusCount>
                  )}
                  {statusCounts.rejected > 0 && (
                    <StatusCount $statusColor={getStatusColor(2)}>
                      {statusCounts.rejected} ביטול
                    </StatusCount>
                  )}
                  {statusCounts.approved > 0 && (
                    <StatusCount $statusColor={getStatusColor(1)}>
                      {statusCounts.approved} אושר
                    </StatusCount>
                  )}
                  {statusCounts.panding > 0 && (
                    <StatusCount $statusColor={getStatusColor(3)}>
                      {statusCounts.panding} ממתין
                    </StatusCount>
                  )}
                </ProblemStatusCounts>
              )}
            </TeudaProblemSummary>
          </TitleRow>
        </TitleLayout>
      </TitleWrapper>
      {
        isOpen && (
          <BodyWrapper
            onClick={(e) => e.stopPropagation()}
          >
            {
              PalletDetails.map((item, index) => {
                return (
                  <TeudaDetailsItem
                    key={index}
                    {...item}
                    handleSelect={handleSelectProduct}
                    item={item}
                  />
                )
              })
            }
          </BodyWrapper>
        )
      }
    </MainWrapper>
  )
}

const TitleWrapper = styled.div`
  width: 100%;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: 0.5em;
  width: 100%;
  padding: 0.5em;
`

const MainWrapper = styled.div<{ $hasProblems?: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: column;
  border-radius: 25px;
  background-color: #E9F0F0;
`

const TeudaProblemSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  align-items: flex-end;
`


const ProblemStatusCounts = styled.div`
  display: flex;
  gap: 0.3em;
  flex-wrap: wrap;
`

const StatusCount = styled.div<{ $statusColor: string }>`
  background: ${props => props.$statusColor};
  color: ${props => props.$statusColor};
  border: 1px solid ${props => props.$statusColor};
  padding: 0.15em 0.3em;
  border-radius: 8px;
  font-size: 0.65rem;
  font-weight: 500;
`

const TeudaProblemIndicator = styled.div<{ $statusColor: string }>`
  position: absolute;
  top: 1em;
  right: 1em;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${props => props.$statusColor};
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  z-index: 3;
`

export default TeudaWithDetails